import { type ActionItem } from 'shared/ui'

export const cancelNumberDisabled = (): ActionItem => {
  return {
    icon: 'slashCircle',
    text: 'Cancel',
    buttonProps: {
      disabled: true,
    },
  }
}
